import "./dropMenu.styles.css";
import React, { useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import { products } from "../../data/products";
import useClickOutside from "../../helpers/clickOutside.helper";

const DropMenu = ({ showDropMenu, setshowDropMenu, handleClose, id }) => {
  const dropMenu = useRef(null);
  const firstLinkRef = useRef(null);

  useClickOutside(dropMenu, () => {
    setshowDropMenu(false);
  });

  // Focus management for keyboard navigation
  useEffect(() => {
    if (showDropMenu && firstLinkRef.current) {
      firstLinkRef.current.focus();
    }
  }, [showDropMenu]);

  // Keyboard navigation
  useEffect(() => {
    if (!showDropMenu) return;

    const handleKeyDown = (e) => {
      const links = Array.from(dropMenu.current?.querySelectorAll('a') || []);
      const currentIndex = links.indexOf(document.activeElement);

      switch (e.key) {
        case 'ArrowDown':
          e.preventDefault();
          const nextIndex = currentIndex < links.length - 1 ? currentIndex + 1 : 0;
          links[nextIndex]?.focus();
          break;
        case 'ArrowUp':
          e.preventDefault();
          const prevIndex = currentIndex > 0 ? currentIndex - 1 : links.length - 1;
          links[prevIndex]?.focus();
          break;
        case 'Escape':
          setshowDropMenu(false);
          break;
        case 'Home':
          e.preventDefault();
          links[0]?.focus();
          break;
        case 'End':
          e.preventDefault();
          links[links.length - 1]?.focus();
          break;
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [showDropMenu, setshowDropMenu]);

  const handleDropMenu = () => {
    setshowDropMenu(false);
  };

  const groupedProducts = products.reduce((acc, product) => {
    if (!acc[product.category]) {
      acc[product.category] = [];
    }
    acc[product.category].push(product.name);
    return acc;
  }, {});
  return (
    <>
      {showDropMenu && (
        <div
          className="drop-menu"
          id={id}
          role="menu"
          aria-label="Products dropdown menu"
          onMouseEnter={() => {
            setshowDropMenu(true);
          }}
          onMouseLeave={(e) => {
            // Only close if mouse is not moving back to the trigger link
            const relatedTarget = e.relatedTarget;
            const isMovingToTrigger = relatedTarget && 
                                      relatedTarget instanceof Element && 
                                      typeof relatedTarget.closest === 'function' &&
                                      relatedTarget.closest('.products-dropdown');
            
            if (!isMovingToTrigger) {
              setTimeout(() => {
                setshowDropMenu(false);
              }, 300);
            }
          }}
          ref={dropMenu}
        >
          <ul className="submenu">
            {Object.entries(groupedProducts).map(([category, productNames], index) => (
              <li key={category} className="list-group">
                <h5>
                  <Link
                    to={`products/${category.toLocaleLowerCase()}`}
                    className="nav-link-header"
                    onClick={handleClose}
                    ref={index === 0 ? firstLinkRef : null}
                  >
                    {category}
                  </Link>
                </h5>

                <ul>
                  {productNames?.map((name, idx) => (
                    <li to="/products/" onClick={handleClose} key={idx}>
                      <Link to={`/product/${name}`} onClick={handleClose}>
                        {name}
                      </Link>
                    </li>
                  ))}
                </ul>
              </li>
            ))}
          </ul>
        </div>
      )}
    </>
  );
};

export default DropMenu;
